import type { DecisionFilters } from "@/infrastructure/repositories/decisions.supabase.repository";

export const decisionsKeys = {
  all: ["decisions"] as const,
  list: (filters: DecisionFilters = {}) => [...decisionsKeys.all, "list", filters] as const,
  detail: (id: string) => [...decisionsKeys.all, "detail", id] as const,
};
